import type { Order } from '@luxuryescapes/contract-svc-order'
import { createSelector } from 'reselect'

import formatItemDiscount from 'lib/payment/formatDiscountItem'
import { getLuxPlusSubscriptionItems } from 'checkout/selectors/view/luxPlusSubscription'
import { getSubReoccuringItemDiscounts, type GetPromoCodeItemDiscounts } from 'checkout/selectors/payment/checkout'

/**
 * Leaf selector for formatted LuxPlus subscription order items.
 * Kept out of orderCreationSelectors so getMerchantFeeAmount can read them
 * without the getMerchantFeeAmount ↔ orderCreationSelectors ↔ bookingProtection cycle.
 */
export type FormattedOrderSubscriptionItem = Pick<Order.SubscriptionItem, 'subscription_offer_id' | 'type' | 'transaction_key' | 'total' | 'sub_type'> & {
  item_discounts?: Array<App.Checkout.FormattedItemDiscount>
  customer_phone?: string
  customer_phone_prefix?: string
}

export const getFormattedLuxPlusSubscriptionItems = createSelector(
  (state: App.State) => getLuxPlusSubscriptionItems(state),
  (state: App.State) => getSubReoccuringItemDiscounts(state),
  (items: Array<App.Checkout.LuxPlusSubscriptionItem>, subReoccuringItemDiscounts: GetPromoCodeItemDiscounts) => {
    if (!subReoccuringItemDiscounts.hasRequiredPromoCodeData) {
      return []
    }
    return items.map<FormattedOrderSubscriptionItem>(item => {
      return {
        subscription_offer_id: item.offerId,
        type: 'subscription',
        transaction_key: item.transactionKey,
        total: item.amount,
        sub_type: 'recurring_fee',
        item_discounts: subReoccuringItemDiscounts.itemDiscounts.map(d => formatItemDiscount(d, item.transactionKey)),
      }
    })
  },
)
